<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            :loading="actionLoading"
        >
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isEditable && showOnly">
                        Zestaw - <strong>{{ setData.name }}</strong>
                    </template>
                    <template v-else>
                        <template v-if="isNewSet">
                            Dodaj zestaw
                        </template>
                        <template v-else>
                            Edycja zestawu - <strong>{{ setData.name }}</strong>
                        </template>
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="setModel.name"
                                :error-messages="setNameErrors"
                                label="Nazwa zestawu"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="setModel.EAN"
                                :error-messages="setEanErrors"
                                label="Ean zestawu"
                                outlined
                                dense
                                persistent-hint
                                required
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="setModel.index"
                                :error-messages="setIndexErrors"
                                label="Index zestawu"
                                outlined
                                dense
                                persistent-hint
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>


            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'

export default {
    name: 'CampaignSetDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        isEditable: {
            type: Boolean
        },
        setData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            setModel: {
                name: null,
                EAN: null,
                index: null,
                products: [],
            },
            actionLoading: false,
        }
    },
    validations() {
        let rules = {
            setModel: {
                name: {
                    required,
                },
                EAN: {
                    required,
                },
                index: {
                    required,
                },
            },
        }

        return rules
    },
    computed: {
        isNewSet() {
            return isEmpty(this.setData)
        },
        setNameErrors() {
            const errors = []

            if (!this.$v.setModel.name.$dirty) return errors
            !this.$v.setModel.name.required && errors.push('Proszę podać nazwę zestawu.')

            return errors
        },
        setEanErrors() {
            const errors = []

            if (!this.$v.setModel.EAN.$dirty) return errors
            !this.$v.setModel.EAN.required && errors.push('Proszę podać EAN zestawu.')

            return errors
        },
        setIndexErrors() {
            const errors = []

            if (!this.$v.setModel.index.$dirty) return errors
            !this.$v.setModel.index.required && errors.push('Proszę podać index zestawu.')

            return errors
        },
    },
    watch: {
        setData(value) {
            if (!isEmpty(value)) {
                this.setModel = {
                    name: value.name,
                    EAN: value.EAN,
                    index: value.index,
                    products: value.products,
                }
            } else {
                this.setInitialData()
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.setModel)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.setInitialData()
                this.actionLoading = false
            }, 500)
            this.$emit('on-close')
        },
        setInitialData() {
            this.setModel = {
                name: '',
                totalAmount: null,
                products: [],
                EAN: null,
                index: null,
            }
            this.$v.$reset()
        },
    }
}
</script>
